import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ColorPickerInput } from "../../editor.style";
const CustomColorPicker = ({ form, value, onChange, }) => {
    return (_jsx(_Fragment, { children: _jsx(ColorPickerInput, { value: value, onChange: onChange, showText: true }) }));
};
export default CustomColorPicker;
